import React from 'react';
import { AlarmClock } from 'lucide-react';

const WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
const OPEN = ['new', 'contacted', 'quoted'];

// Open move requests whose finish-by deadline is within 7 days (or already passed).
export const moveUrgency = (q, now = Date.now()) => {
  const v = q.move_details?.completion_deadline || q.move_completion_deadline;
  if (!v || !OPEN.includes((q.status || 'new').toLowerCase())) return null;
  const ms = new Date(v).getTime() - now;
  if (Number.isNaN(ms) || ms > WINDOW_MS) return null;
  const days = Math.ceil(ms / 86400000);
  const label = ms < 0 ? 'Deadline passed' : ms < 86400000 ? 'Due within 24 hrs' : `Due in ${days} days`;
  return { ms, label, overdue: ms < 0 };
};

export const sortByMoveUrgency = (list) => {
  const now = Date.now();
  const tagged = list.map((q, i) => ({ q, i, u: moveUrgency(q, now) }));
  tagged.sort((a, b) => (a.u && b.u ? a.u.ms - b.u.ms : a.u ? -1 : b.u ? 1 : a.i - b.i));
  return tagged.map(({ q, u }) => ({ ...q, _urgency: u }));
};

export const MoveDeadlineBadge = ({ q }) => {
  if (!q._urgency) return null;
  const deadline = new Date(q.move_details?.completion_deadline || q.move_completion_deadline).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  return (
    <span className={`mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border whitespace-nowrap ${q._urgency.overdue ? 'bg-red-50 text-red-700 border-red-200' : 'bg-orange-50 text-orange-700 border-orange-200'}`}
      title={`Move must be finished by ${deadline}`} data-testid={`move-deadline-badge-${q.id}`}>
      <AlarmClock className="w-3 h-3" />{q._urgency.label} · {deadline}
    </span>
  );
};

export const MoveDeadlineBanner = ({ count }) => (count ? (
  <div className="mb-4 flex items-center gap-2 rounded-lg border border-orange-200 bg-orange-50 px-4 py-3 text-sm text-orange-800" data-testid="move-deadline-banner">
    <AlarmClock className="w-4 h-4" />
    <span><strong>{count}</strong> move request{count === 1 ? '' : 's'} must be finished within 7 days. {count === 1 ? 'It is' : 'They are'} pinned at the top.</span>
  </div>
) : null);
